module.exports = __webpack_public_path__ + "static/media/1-17.f8222f35.mp3";